import React from 'react'

// Local inline glyph, not from @fs/zion-icon: none of the package's icons is
// a door/exit glyph. Standard "log out"/"exit" shape — a door frame open on
// one side with an arrow pointing out through the doorway. The arrow points
// LEFT (door frame on the right), reading as "step out" from the row's
// corner position. Candidate for promotion into the design system later if
// other experiences need it.
export default function ExitDoorIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M15 21h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-4" />
      <polyline points="8 17 3 12 8 7" />
      <line x1="3" y1="12" x2="15" y2="12" />
    </svg>
  )
}
